var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22076 4.5H9.78076C10.7804 4.5 11.3529 4.84971 11.5969 5.27248C11.8411 5.6955 11.8574 6.36634 11.361 7.23012C11.3609 7.23035 11.3608 7.23057 11.3606 7.23079L10.8684 8.08227C10.8683 8.08238 10.8682 8.08249 10.8682 8.0826C10.8378 8.13462 10.7828 8.16667 10.7208 8.16667H5.28076C5.21866 8.16667 5.16368 8.1346 5.13332 8.08255C5.13327 8.08245 5.13321 8.08236 5.13316 8.08227L4.6409 7.23079C4.6408 7.23063 4.64071 7.23046 4.64061 7.23029C4.14412 6.36643 4.1604 5.69553 4.40462 5.27248C4.64867 4.84971 5.22113 4.5 6.22076 4.5Z",
    fill: "#464650",
    stroke: "#464650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85906 9.33301H10.1457C10.4057 9.33301 10.5657 9.61301 10.4324 9.83301L10.0057 10.5663C8.90573 12.4797 7.0924 12.4797 5.9924 10.5663L5.56573 9.83301C5.43906 9.61301 5.59906 9.33301 5.85906 9.33301Z",
    fill: "#464650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.deed0d4b975df28751a953f4388c8c28.svg";
export { ForwardRef as ReactComponent };